import { statementSearch } from "@/api/statements.service";
import { currencyFormat, timestampFormatter } from "@/util/helpers";
export const useStatementSearch = () => {
  return {
    itemTitle: i => {
      return [
        i.payor?.name,
        timestampFormatter(i.statementDate, "sole-day"),
        i.amount ? currencyFormat(i.amount) : null
      ]
        .filter(Boolean)
        .join(" - ");
    },
    comparisonValue: v => v?.id,
    fetchResults: async (v, searchArgs) => {
      const res = await statementSearch({
        search: v,
        carrier_id: searchArgs.carrierId
      });

      return res
        .toSorted(
          (a, b) => new Date(a.statementDate) - new Date(b.statementDate)
        )
        .toReversed();
    }
  };
};
